import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export class CustomValidators {
  public static decimal(precision: number, scale: number): ValidatorFn {
    return (abstractControl: AbstractControl) => {
      if (abstractControl && abstractControl.value) {
        const valor = (abstractControl.value as number).toString();

        if (valor.replace(',', '').length > precision) {
          return {decimal: true};
        }

        const partes: Array<string> = valor.split(',');
        if (partes.length == 2) {
          const parteDecimal = partes[1];
          if (parteDecimal.length > scale) {
            return {decimal: true};
          }
        }
      }

      return null;
    };
  }

  public static validaCPF(control: AbstractControl): {[key: string]: boolean} | null {
    let invalid: {[key: string]: boolean} = {validaCPF: true};
    let cpf: string = control.value;
    if (cpf == null) {
      return invalid;
    }
    if (cpf.length != 11) {
      return invalid;
    }
    if (
      cpf == '00000000000' ||
      cpf == '11111111111' ||
      cpf == '22222222222' ||
      cpf == '33333333333' ||
      cpf == '44444444444' ||
      cpf == '55555555555' ||
      cpf == '66666666666' ||
      cpf == '77777777777' ||
      cpf == '88888888888' ||
      cpf == '99999999999'
    ) {
      return invalid;
    }
    let numero: number = 0;
    let caracter: string = '';
    let numeros: string = '0123456789';
    let j: number = 10;
    let somatorio: number = 0;
    let resto: number = 0;
    let digito1: number = 0;
    let digito2: number = 0;
    let cpfAux: string = '';

    cpfAux = cpf.substring(0, 9);
    for (let i: number = 0; i < 9; i++) {
      caracter = cpfAux.charAt(i);
      if (numeros.search(caracter) == -1) {
        return invalid;
      }
      numero = Number(caracter);
      somatorio = somatorio + numero * j;
      j--;
    }
    resto = somatorio % 11;
    digito1 = 11 - resto;
    if (digito1 > 9) {
      digito1 = 0;
    }
    j = 11;
    somatorio = 0;
    cpfAux = cpfAux + digito1;
    for (let i: number = 0; i < 10; i++) {
      caracter = cpfAux.charAt(i);
      numero = Number(caracter);
      somatorio = somatorio + numero * j;
      j--;
    }
    resto = somatorio % 11;
    digito2 = 11 - resto;
    if (digito2 > 9) {
      digito2 = 0;
    }
    cpfAux = cpfAux + digito2;
    if (cpf != cpfAux) {
      return invalid;
    } else {
      return null;
    }
  }

  /***
   * igual ao validaCPF, porém só marca erro se CPF estiver algum valor preenchido
   * Só foi criado para evitar afetar as telas que usam o validaCPF original
   */
  public static validateCPF(control: AbstractControl): {[key: string]: boolean} | null {
    let invalid: {[key: string]: boolean} = {validateCPF: true};
    let cpf: string = control.value;
    if (!cpf) {
      return null;
    }

    if (
      cpf == '00000000000' ||
      cpf == '11111111111' ||
      cpf == '22222222222' ||
      cpf == '33333333333' ||
      cpf == '44444444444' ||
      cpf == '55555555555' ||
      cpf == '66666666666' ||
      cpf == '77777777777' ||
      cpf == '88888888888' ||
      cpf == '99999999999'
    ) {
      return invalid;
    }
    let numero: number = 0;
    let caracter: string = '';
    let numeros: string = '0123456789';
    let j: number = 10;
    let somatorio: number = 0;
    let resto: number = 0;
    let digito1: number = 0;
    let digito2: number = 0;
    let cpfAux: string = '';

    cpfAux = cpf.substring(0, 9);
    for (let i: number = 0; i < 9; i++) {
      caracter = cpfAux.charAt(i);
      if (numeros.search(caracter) == -1) {
        return invalid;
      }
      numero = Number(caracter);
      somatorio = somatorio + numero * j;
      j--;
    }
    resto = somatorio % 11;
    digito1 = 11 - resto;
    if (digito1 > 9) {
      digito1 = 0;
    }
    j = 11;
    somatorio = 0;
    cpfAux = cpfAux + digito1;
    for (let i: number = 0; i < 10; i++) {
      caracter = cpfAux.charAt(i);
      numero = Number(caracter);
      somatorio = somatorio + numero * j;
      j--;
    }
    resto = somatorio % 11;
    digito2 = 11 - resto;
    if (digito2 > 9) {
      digito2 = 0;
    }
    cpfAux = cpfAux + digito2;
    if (cpf != cpfAux) {
      return invalid;
    } else {
      return null;
    }
  }

  public static validaCNPJ(control: AbstractControl): {[key: string]: boolean} | null {
    if (!control.value) return null;

    let invalid: {[key: string]: boolean} = {validaCNPJ: true};
    let cnpj: string = control.value;

    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj == '') return invalid;

    if (cnpj.length != 14) return invalid;

    if (
      cnpj == '00000000000000' ||
      cnpj == '11111111111111' ||
      cnpj == '22222222222222' ||
      cnpj == '33333333333333' ||
      cnpj == '44444444444444' ||
      cnpj == '55555555555555' ||
      cnpj == '66666666666666' ||
      cnpj == '77777777777777' ||
      cnpj == '88888888888888' ||
      cnpj == '99999999999999'
    )
      return invalid;

    let tamanho: number = cnpj.length - 2;
    let numeros: string = cnpj.substring(0, tamanho);
    let digitos: string = cnpj.substring(tamanho);
    let soma: number = 0;
    let pos: number = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
      if (pos < 2) pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != parseInt(digitos.charAt(0))) return invalid;
    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
      if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != parseInt(digitos.charAt(1))) return invalid;

    return null;
  }

  /**
   * Avalia se está dentro do intervalo. Caso negativo, marca o formControl com o error `range`. `Só testei com number! Tem q checar outros tipos`
   * @param {T} T o `Tipo` de dado contido no formControl
   * @param {T} minValue menor valor permitido
   * @param {T} maxValue maior valor permitido
   * @returns ValidatorFn | null
   */
  public static range<T extends Number>(minValue: T, maxValue: T): ValidatorFn | null {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control || isNaN(control.value) || control.value == null) {
        return null;
      }

      let controlValue: Number = Number(control.value);

      if (controlValue < minValue || controlValue > maxValue) {
        return {range: true};
      }
      return null;
    };
  }

  /**
   * Verifica se o valor deste formControl é maior que o valor retornado pelo parâmetro `otherValue`.
   * Caso negativo, marca o este formControl com o error `greaterThan`. `Só testei com T:number! Tem q checar outros Tipos`
   * @param {T} T o `Tipo` de dado contido neste formControl, bem como o tipo retornado pelo parâmetro `otherValue`
   * @param otherValue `() => T` é parâmetro do tipo function que retorna o valor a ser comparado com este. Útil para comparar com outro formControl
   * @param {T} otherValue T é um parâmetro comum
   * @returns ValidatorFn | null
   */

  // verifica se o valor do input e > 100

  /**
   * Verifica se o valor deste formControl é menor que o valor retornado pelo parâmetro `otherValue`.
   * Caso negativo, marca o este formControl com o error `dateSmallerThan`.
   * @param otherValue `() => T` é parâmetro do tipo function que retorna o valor do tipo `Date` a ser comparado com este formControl.
   * @param {T} otherValue Date é um parâmetro comum do tipo Date
   * @returns ValidatorFn | null
   */
  public static dateSmallThan<T extends Date>(otherValue: (() => T) | T): ValidatorFn | null {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value == null) {
        return null;
      }
      let controlDate = new Date(control.value);
      let comparisonDate: Date;
      let other: any;
      if (typeof otherValue == 'function') {
        other = otherValue();
      } else {
        other = otherValue;
      }
      comparisonDate = other;
      if (comparisonDate <= controlDate) {
        return {dateSmallThan: true};
      }
      return null;
    };
  }
  /**
   * Se a expression retornar true, marca o formControl com o error 'inspect'
   * @param {()} expression function que retorna boolean
   * @returns ValidatorFn | null
   */

  /**
   * Se a expression retornar true, marca o formControl com o error 'inspect'
   * @param {()} expression function que retorna boolean
   * @returns ValidatorFn | null
   */
  public static inspect = (expression: () => boolean): ValidatorFn | null => {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value == null) {
        return null;
      }
      if (expression()) {
        return {inspect: true};
      }
      return null;
    };
  };

  public static rertornarIdadeForm(aniversario: any, control: AbstractControl): void {
    // Verifica se a data de nascimento está presente e é válida
    if (!aniversario || isNaN(Date.parse(aniversario))) {
      control.get('age')?.setValue(''); // Limpa o campo de idade se a data for inválida
      return;
    }

    const hoje = new Date();
    const nascimento = new Date(aniversario);

    // Verifica se a data de nascimento é válida e não é no futuro
    if (nascimento > hoje) {
      control.get('age')?.setValue('0'); // Alterado para 0 pois o campo de data fica com a data atual
      return;
    }

    const diff = hoje.getTime() - nascimento.getTime();
    let idadeAnos = Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));

    // Caso a idade seja negativa ou NaN, defina como 0
    if (isNaN(idadeAnos) || idadeAnos < 0) {
      idadeAnos = 0;
    }

    control.get('age')?.setValue(idadeAnos);
  }
  public static calcularIdadePessoa(aniversario: any): any {
    const hoje = new Date();
    const nascimento = new Date(aniversario);

    // Verifica se a data de nascimento é válida e não é no futuro
    if (nascimento > hoje) {
      return;
    }

    const diff = hoje.getTime() - nascimento.getTime();
    let idadeAnos = Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));

    // Caso a idade seja negativa ou NaN, defina como 0
    if (isNaN(idadeAnos) || idadeAnos < 0) {
      idadeAnos = 0;
    }

    return idadeAnos;
  }

  public static imageDimensionsValidator(maxWidth: number, maxHeight: number): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      const file = control.value;

      if (file instanceof File) {
        return new Promise(resolve => {
          const img = new Image();
          const reader = new FileReader();

          reader.onload = (e: any) => {
            img.src = e.target.result;

            img.onload = () => {
              if (img.width > maxWidth || img.height > maxHeight) {
                resolve({
                  dimensions: `As dimensões da imagem (${img.width}x${img.height}) excedem o limite máximo de ${maxWidth}x${maxHeight} pixels`,
                });
              } else {
                resolve(null);
              }
            };
          };

          reader.readAsDataURL(file);
        });
      }

      return null;
    };
  }
}
